import { useIsMobile } from "@/hooks/use-mobile";
import { Dialog } from "@/components/ui/dialog";
import { AppointmentForm } from "@/components/calendar/AppointmentForm";
import { MobileAppointmentCreateDrawer } from "@/components/calendar/mobile/appointment/MobileAppointmentCreateDrawer";
import type { AppointmentTypeBehavior } from "@/hooks/useClinicAppointmentTypes";

interface AppointmentFormResponsiveDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  clinicId: string;
  prefilledDate?: Date;
  prefilledTime?: string;
  prefilledEndTime?: string;
  prefilledOwnerId?: string;
  prefilledPetId?: string;
  prefilledPetIds?: string[];
  prefilledVetId?: string;
  prefilledType?: string;
  prefilledBehavior?: AppointmentTypeBehavior;
  onSuccess?: () => void;
}

export function AppointmentFormResponsiveDialog({
  open,
  onOpenChange,
  onSuccess,
  ...formProps
}: AppointmentFormResponsiveDialogProps) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <MobileAppointmentCreateDrawer
        open={open}
        onOpenChange={onOpenChange}
        onSuccess={onSuccess}
        {...formProps}
      />
    );
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {open && (
        <AppointmentForm
          mode="create"
          onClose={() => onOpenChange(false)}
          onSuccess={() => {
            onSuccess?.();
            onOpenChange(false);
          }}
          {...formProps}
        />
      )}
    </Dialog>
  );
}
